import { mimshakDataPreAdviceService } from "../services/mimshakDataPreAdviceService";
import { queryKeys } from "../queries/queryKeys";
import { createMimshakHooks } from "./createMimshakHooks";

// ✅ יצירת כל ה-hooks עבור Mimshak PreAdvice
const hooks = createMimshakHooks({
  service: mimshakDataPreAdviceService,
  queryKeys: {
    byPeriod: (userId: number, period: string) => [queryKeys.mimshakPreAdviceDataByPeriod, userId, period],
    latestRecords: (userId: number) => [queryKeys.mimshakPreAdviceLatestRecords, userId],
    latestRecordsBatch: (userIds: string) => [queryKeys.mimshakPreAdviceLatestRecords, "byContacts", userIds],
    byPeriodBatch: (userIds: string, period: string) => ["mimshakPreAdviceData", "byPeriodBatch", userIds, period],
  },
});

// ✅ ייצוא כל ה-hooks
export const usePreAdviceMimshaksByContactAndPeriod = hooks.useMimshaksByContactAndPeriod;
export const usePreAdviceMimshaksByContactsAndPeriod = hooks.useMimshaksByContactsAndPeriod;
export const useLatestPreAdviceMimshakByContact = hooks.useLatestMimshakByContact;
export const useLatestPreAdviceMimshaksByContacts = hooks.useLatestMimshaksByContacts;
//export const useUpsertPreAdviceMimshakData = hooks.useUpsertMimshakData;
